import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  src: "https://johnarban.github.io/wwt_interactives/images/m101/hubble_m101/thumb.jpg"
}
const _hoisted_3 = {
  key: 1,
  class: "thumbnail-header"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "thumbnail-header"
}
const _hoisted_7 = { id: "items" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "item-thumbnails" }
const _hoisted_11 = ["src", "alt", "onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "slider-container" }
const _hoisted_14 = ["onInput", "onKeyup"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_transition_expand = _resolveComponent("transition-expand")!

  return (_openBlock(), _createElementBlock("div", {
    class: "fv-root",
    style: _normalizeStyle(_ctx.cssVars)
  }, [
    (_ctx.expandable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "expand-row",
          class: "bordered pa-1",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
        }, [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.thumbnails)
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : _createCommentVNode("", true),
            (_ctx.expanded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[2] || (_cache[2] = _createTextVNode(" Click ")),
                  (_ctx.thumbnails)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "thumbnail"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, "date")),
                  _cache[3] || (_cache[3] = _createTextVNode(" to see image in sky "))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.expanded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Image Controls "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_font_awesome_icon, {
            id: "expand-icon",
            icon: _ctx.expanded ? 'chevron-up' : 'chevron-down'
          }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_transition_expand, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          (_ctx.items !== null && _ctx.expanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(['bordered', 'item', _ctx.lastSelectedItem === item ? 'selected' : '']),
                    key: item.get_name(),
                    id: `fv-${item.get_name()}`
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.thumbnails)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "thumbnail-images",
                            src: item.get_thumbnailUrl(),
                            alt: item.get_name(),
                            onClick: () => _ctx.selectItem(item)
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      (_ctx.showName)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["item-name", ['thumbnail']]),
                            onClick: () => _ctx.selectItem(item)
                          }, _toDisplayString(_ctx.displayName(item)), 9, _hoisted_12))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.sliders)
                        ? (_openBlock(), _createElementBlock("input", {
                            key: 0,
                            class: "opacity-range",
                            type: "range",
                            value: "0",
                            onInput: (e) => _ctx.onSliderInputChanged(e , item),
                            onKeyup: _withKeys(() => _ctx.selectItem(item), ["enter"]),
                            onMouseup: _cache[1] || (_cache[1] = () => { _ctx.lastOpacityChanged = null})
                          }, null, 40, _hoisted_14))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_9))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 4))
}